
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"5.97","y":"1","fill":"#000","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"15.02","y":"1","fill":"#000","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"20.1","height":"5.53","x":"1.95","y":"3.9","fill":"#FAB4CD","fill-rule":"nonzero","rx":"1.32"}}),_c('rect',{attrs:{"width":"20.1","height":"19.1","x":"1.95","y":"3.9","stroke":"#000","rx":"1.96"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M17 13.81c.089.095.139.22.14.35a.511.511 0 01-.15.35l-5.76 5.77a.481.481 0 01-.34.14.449.449 0 01-.34-.15l-3.3-3.39a.481.481 0 01-.14-.34.561.561 0 01.15-.35l1.14-1.14a.457.457 0 01.34-.15c.13.008.254.06.35.15l1.85 1.89 4.27-4.28a.449.449 0 01.34-.15c.129.003.25.057.34.15L17 13.82v-.01z"}}),_c('path',{attrs:{"stroke":"#000","d":"M1.95 9.43h20.1"}})])])
          )
        }
      }
    